import React from "react";

export default function PickupStep({
  trip,
  onMarkPickedUp,
  updating,
  onOpenCancelModal,
}) {
  return (
    <div className="space-y-4">
      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 flex items-center justify-between">
        <div>
          <span className="text-xs uppercase font-bold text-blue-700">
            Step 1 of 2
          </span>
          <p className="font-bold text-gray-900 text-sm mt-0.5">
            Head to Pickup Location
          </p>
        </div>
        <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-bold text-sm">
          1
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 p-5 space-y-4 shadow-sm">
        <div>
          <p className="text-xs text-gray-400 font-semibold uppercase">
            Seller / Pickup
          </p>
          <p className="font-bold text-gray-900 text-base mt-1">
            {trip.seller_name}
          </p>
          <p className="text-sm text-gray-600 mt-0.5">{trip.pickup_address}</p>
          {trip.seller_phone && (
            <a
              href={`tel:${trip.seller_phone}`}
              className="inline-flex items-center gap-1.5 text-xs text-emerald-600 font-semibold mt-2 bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-200"
            >
              📞 Call Seller ({trip.seller_phone})
            </a>
          )}
        </div>

        {trip.item_description && (
          <div className="border-t border-gray-100 pt-3">
            <p className="text-xs text-gray-400 font-semibold uppercase">
              Item Details
            </p>
            <p className="text-sm text-gray-700 mt-0.5">
              {trip.item_description} ({trip.weight_estimate_kg || "Under 1kg"})
            </p>
          </div>
        )}
      </div>

      <button
        onClick={onMarkPickedUp}
        disabled={updating}
        className="w-full py-4 rounded-2xl bg-emerald-500 text-white font-bold text-base hover:bg-emerald-600 active:scale-95 transition-all shadow-md shadow-emerald-500/20 disabled:opacity-50"
      >
        {updating ? "Updating..." : "MARK AS PICKED UP"}
      </button>

      <button
        onClick={onOpenCancelModal}
        className="w-full py-2.5 text-xs text-red-500 hover:text-red-700 font-medium text-center"
      >
        Cannot complete pickup? Cancel trip
      </button>
    </div>
  );
}
